export const noContractMenu = [
  'contact',
  'legalInformation',
  'raiseComplaint',
  'home',
  'myAccount',
  'SIGN_OUT',
  'notification',
];

export const noSideMenuList = ['termsAndConditions'];

export const isItemHidden = (listName, view) => listName.includes(view);
